import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Divider} from 'shells/layout/divider';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {RelativeTimestamp} from 'shells/timestamp/relative-timestamp';

type Props = {
    numBookings: number;
    lastBookedTime?: number | null | undefined;
};

export function MeetingBookingInfo(props: Props) {
    return (
        <div className='flex align-center'>
            <div>
                {props.numBookings}
                {props.numBookings === 1 ? ' booking' : ' bookings'}
            </div>
            {props.lastBookedTime ? (
                <>
                    <Divider spacing={4} variant='dot' color={colors.greyLt} />
                    <StackLegacy spacing={4} isHorizontal={true} alignCenter={true}>
                        <div>Last booked</div>
                        <RelativeTimestamp datetime={props.lastBookedTime} />
                    </StackLegacy>
                </>
            ) : null}
        </div>
    );
}
